export default {
  AGENCY: {
    "101001": "/org/agency/brand",
    "105001": "/org/agency/template"
  },
  AUXI: {
    "401001": "/auxil/comment/repay",
    "402001": "/auxil/comment/free",
    "403001": "/auxil/comment/return",
    "404001": "/auxil/comment/given",
    "405001": "/auxil/comment/discount",
    "406001": "/auxil/comment/taste"
  },
  WCT_SHOW: {
    "100100101": "/wct/shows/wctCover",
    "100100201": "/wct/shows/hotelSorting",
    "100100301": "/wct/shows/loadHotelPicture"
  },
  WCT_QR: {
    "100300101": "/wct/qrcode",
    "100300201": "/wct/qrcode/table"
  },
  CRM_CARD: {
    "50200101": "/crm/card/make",
    "50200201": "/crm/card/delivery",
    "2050200101": "/crm/card/make",
    "2050200201": "/crm/card/delivery"
  },
  SDS_HOTEL: {
    "70110101": "/sds/hotel/report/goodsBatch",
    "70110201": "/sds/hotel/report/inoutAmount",
    "70110301": "/sds/hotel/report/inoutAmountDetail",
    "70110401": "/sds/hotel/report/profitLoss",
    "70110501": "/sds/hotel/report/stocktaking",
    "70110601": "/sds/hotel/report/supplier",
    "70110701": "/sds/hotel/report/orderDifference",
    "70110801": "/sds/hotel/report/procurement"
  },
  SDS_GROUP: {
    "80160101": "/sds/group/report/goodsBatch",
    "80160201": "/sds/group/report/inoutAmount",
    "80160301": "/sds/group/report/inoutAmountDetail",
    "80160401": "/sds/group/report/profitLoss",
    "80160501": "/sds/group/report/stocktaking",
    "80160601": "/sds/group/report/supplier"
  },
  SDS_GOODS: {
    "70180101": "/sds/group/goods",
    "701802": "/sds/group/category",
    "701803": "/sds/group/unit",
    "701804": "/sds/group/priceAgreement"
  },
  HOTEL_PURCHASE: {
    "701701": "/sds/hotel/purchase/order",
    "702201": "/sds/hotel/purchase/orderPanel"
  }
};



// WEBPACK FOOTER //
// ./src/constants/menu-uxiliary.js